import axios from 'axios';
import { useState } from 'react';
import useReveal from '../components/useReveal';
import styles from './Contact.module.css';

const CONTACT = {
  whatsapp: 'https://wa.me/919760194928?text=Hi%20404%20Stack!%20I%27d%20like%20to%20discuss%20a%20project.',
  phone: 'tel:+919760194928',
  instagram: 'https://www.instagram.com/404_stack?igsh=MzRuY284bTByZzF1&utm_source=qr',
  linkedin: 'https://www.linkedin.com/company/404-stack/?viewAsMember=true',
  email: 'mailto:info.404stack@gmail.com',
};

const channels = [
  {
    key: 'whatsapp',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    label: 'WhatsApp',
    sub: 'Chat instantly',
    color: '#25d366',
    bg: 'rgba(37,211,102,0.1)',
    border: 'rgba(37,211,102,0.25)',
    href: CONTACT.whatsapp,
    external: true,
  },
  {
    key: 'phone',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    label: 'Call Us',
    sub: '+91 9760194928',
    color: 'var(--accent)',
    bg: 'rgba(0,229,255,0.1)',
    border: 'rgba(0,229,255,0.25)',
    href: CONTACT.phone,
    external: false,
  },
  {
    key: 'instagram',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    label: 'Instagram',
    sub: '404_stack',
    color: '#e1306c',
    bg: 'rgba(225,48,108,0.1)',
    border: 'rgba(225,48,108,0.25)',
    href: CONTACT.instagram,
    external: true,
  },
  {
    key: 'linkedin',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    label: 'LinkedIn',
    sub: '404 Stack',
    color: '#0077b5',
    bg: 'rgba(0,119,181,0.1)',
    border: 'rgba(0,119,181,0.25)',
    href: CONTACT.linkedin,
    external: true,
  },
  {
    key: 'email',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    label: 'Email Us',
    sub: 'info.404stack@gmail.com',
    color: '#ea4335',
    bg: 'rgba(234,67,53,0.1)',
    border: 'rgba(234,67,53,0.25)',
    href: CONTACT.email,
    external: false,
  },
];

const services = [
  'Full-Stack Web Development', 'Frontend Development', 'Backend Development',
  'SEO & Website Ranking', 'Google Ads & Marketing', 'Social Media Management',
  'Google Business Profile', 'Website Maintenance', 'Other',
];

export default function Contact() {
  const heroRef = useReveal();
  const channelsRef = useReveal();
  const formRef = useReveal();

  const [form, setForm] = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await axios.post( `${process.env.REACT_APP_BACKEND_URL}/api/contact`, form);
      setStatus('success');
      setForm({ name: '', email: '', phone: '', service: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className={styles.page}>
      {/* Hero */}
      <div className={styles.heroWrap}>
        <div className={styles.heroGlow} />
        <div className={styles.heroGrid} />
        <div className={`reveal ${styles.heroContent}`} ref={heroRef}>
          <span className="section-label" style={{ textAlign: 'center', display: 'block' }}>// get in touch</span>
          <h1 className={styles.heroTitle}>
            Let's Build Something<br /><em>Great Together</em>
          </h1>
          <p className={styles.heroSub}>
            Reach us on your preferred channel — we respond fast. Choose how you'd like to connect below.
          </p>
        </div>
      </div>

      {/* Channel Cards */}
      <section className={styles.channelsSection}>
        <div className={`reveal ${styles.channelGrid}`} ref={channelsRef}>
          {channels.map((ch) => (
            <a
              key={ch.key}
              href={ch.href}
              target={ch.external ? '_blank' : undefined}
              rel={ch.external ? 'noreferrer' : undefined}
              className={styles.channelCard}
              style={{ '--ch-color': ch.color, '--ch-bg': ch.bg, '--ch-border': ch.border }}
            >
              <div className={styles.chIcon}>{ch.icon}</div>
              <div>
                <div className={styles.chLabel}>{ch.label}</div>
                <div className={styles.chSub}>{ch.sub}</div>
              </div>
              <span className={styles.chArrow}>→</span>
            </a>
          ))}
        </div>
      </section>

      {/* Form + Info */}
      <section className={styles.formSection}>
        <div className={styles.formWrap}>
          {/* Left: Form */}
          <div className={`reveal ${styles.formCard}`} ref={formRef}>
            <h2 className={styles.formTitle}>Send Us a Message</h2>
            <p className={styles.formSub}>Fill in the details and we'll get back to you within 24 hours.</p>

            {status === 'success' && (
              <div className={styles.successMsg}>
                ✅ Message received! We'll get back to you soon.
              </div>
            )}
            {status === 'error' && (
              <div className={styles.errorMsg}>
                ❌ Something went wrong. Please try again or contact us directly.
              </div>
            )}

            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.row}>
                <div className={styles.field}>
                  <label>Your Name *</label>
                  <input
                    type="text" name="name" placeholder="John Doe"
                    value={form.name} onChange={handleChange} required
                  />
                </div>
                <div className={styles.field}>
                  <label>Email Address *</label>
                  <input
                    type="email" name="email" placeholder="john@company.com"
                    value={form.email} onChange={handleChange} required
                  />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.field}>
                  <label>Phone Number</label>
                  <input
                    type="tel" name="phone" placeholder="+91 99999 99999"
                    value={form.phone} onChange={handleChange}
                  />
                </div>
                <div className={styles.field}>
                  <label>Service Interested In</label>
                  <select name="service" value={form.service} onChange={handleChange}>
                    <option value="">Select a service</option>
                    {services.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className={styles.field}>
                <label>Your Message *</label>
                <textarea
                  name="message" rows={5} placeholder="Tell us about your project, goals, or questions..."
                  value={form.message} onChange={handleChange} required
                />
              </div>
              <button type="submit" className={styles.submitBtn} disabled={status === 'loading'}>
                {status === 'loading' ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>

          {/* Right: Info */}
          <div className={styles.infoCol}>
            <div className={styles.infoCard}>
              <h3>Quick Connect</h3>
              <p>Prefer a faster response? Reach us directly through any of these channels:</p>
              <div className={styles.quickLinks}>
                <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className={`${styles.ql} ${styles.qlWa}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  WhatsApp Chat
                </a>
                <a href={CONTACT.phone} className={`${styles.ql} ${styles.qlCall}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                  +91 9760194928
                </a>
                <a href={CONTACT.email} className={`${styles.ql} ${styles.qlMail}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                  info.404stack@gmail.com
                </a>
              </div>
            </div>

            <div className={styles.infoCard}>
              <h3>Follow Us</h3>
              <p>Stay updated with our latest work and insights.</p>
              <div className={styles.socialPair}>
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className={`${styles.ql} ${styles.qlIg}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                  Instagram
                </a>
                <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" className={`${styles.ql} ${styles.qlLi}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                  LinkedIn
                </a>
              </div>
            </div>

            <div className={styles.responseCard}>
              <div className={styles.respIcon}>⚡</div>
              <div>
                <strong>Fast Response Guarantee</strong>
                <p>We reply to all messages within 24 hours — usually much faster.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
